import { Box, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { PROGRESS_TYPE_DOCUMENTS, PROGRESS_TYPE_QUESTIONS, ProgressProps } from './types';

const TaskCompletionProgress = ({ value, display, total, completed, pending, type = PROGRESS_TYPE_DOCUMENTS }: ProgressProps) => {
  const completedLabel = type === PROGRESS_TYPE_QUESTIONS ? 'answered' : 'uploaded';
  
  return (
    <Box display="flex" alignItems="center">
      <Box position="relative" display="inline-flex">
        <CircularProgress color="secondary" variant="determinate" value={value} />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center">
          <Typography variant="caption" component="div" color="textSecondary">
            {display}
          </Typography>
        </Box>
      </Box>
      <Typography style={{ marginLeft: '0.5rem' }}>
        Requests: {total} sent, {completed} {completedLabel}, {pending} pending
      </Typography>
    </Box>
  );
};

export default TaskCompletionProgress;
